// @ts-nocheck
﻿import React, {  useCallback } from 'react';
import { useFormContext,  } from 'react-hook-form';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import { useAuth } from './AuthProvider';
import { Typography } from '@mui/material';


const useStyles = makeStyles((theme)=>({
    root: {
        maxWidth: 500
    },
    margin: {
        //margin: theme.spacing(2)
    }
}));

export const Form = ({ onSubmit, title, setLoading, ...props }) => {
    const [auth] = useAuth();
    const { handleSubmit } = useFormContext();
    const classes = useStyles();

    /*useEffect(() => {
        const loadScriptByURL = (id, url, callback) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                script.onload = function () {
                    if (callback) callback();
                };
                document.body.appendChild(script);
            }

            if (isScriptExist && callback) callback();
        }

        if(auth==null) return;

        if(auth.config.captchaKey==="DISABLE_UNSAFE")
            return;

        // load the script by passing the URL
        loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${auth.config.captchaKey}`, function () {
            //console.log("Script loaded!");
        });
    }, [auth]);*/

    const onSubmitWithToken = useCallback((data, event) => {
        if (setLoading)
            setLoading(true);
        event.preventDefault();
        
        //if(auth.config.captchaKey==="DISABLE_UNSAFE")
            onSubmit(data, "DISABLED", event);
        /*else
            window.grecaptcha.ready(() => {
                window.grecaptcha.execute(auth.config.captchaKey, { action: 'submit' }).then(token => {
                    onSubmit(data, token, event);
                });
            });*/

    }, [onSubmit, setLoading]);


     return (
        <div className='form'>
            <img className='pageLogo' src={auth.config.bannerLogo} alt="Logo" />
             {title && <Typography className='title' variant="h5" color='text' gutterBottom={true}>{title}</Typography>}

        
             <form onSubmit={onSubmit ? handleSubmit(onSubmitWithToken):null}>
                          
                    <Grid container component="main" className={classes.root} spacing={2}>
                        {props.children}
                    </Grid>
                </form>
         
        </div>
       
    );
};